import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useMoi } from '../Auth/moi.ts';
import { libelleDistance } from '../Construction/distanceCourse.ts';

// Course preparee par l'athlete (page Mes preferences, onglet Ma
// preparation) : fixee par son coach (page Athletes), consultee ici sans
// pouvoir la modifier.
export default function CoursePreparee() {
  const moi = useMoi();
  const distance = libelleDistance(moi?.distancePreparee);

  return (
    <Box id="preference-course-preparee" sx={{ mt: 4 }}>
      <h2>Ma préparation</h2>
      <Typography variant="body2" color="text.secondary">Course préparée</Typography>
      <Typography variant="h5" sx={{ mb: 2 }}>{moi ? distance ?? 'Non renseignée' : '…'}</Typography>
      <Typography color="text.secondary">
        {moi?.coach
          ? <>C'est ton coach ({moi.coach}) qui fixe la course que tu prépares : tes séances sont construites pour elle. Pour la changer, parle-lui-en.</>
          : 'La course préparée est fixée par ton coach. Tu n\'es rattaché à aucun coach pour l\'instant.'}
      </Typography>
    </Box>
  );
}
